export const Endpoint = 'tasks/set-ic-tasks-order';
export const Method = 'POST';
export const RateLimitingConfig = {
    calls: 1,
    per: 1500,
};
